// extracted by mini-css-extract-plugin
module.exports = {"lease-period":"c6e8ba5398--lease-period--BAnbK"};